import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import RefreshIcon from "@mui/icons-material/Refresh";
import CustomTableWithPagination from "../../components/customTable/CustomTable";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CopyableText from "../../components/copyableText/CopyableText";

import { getFormattedDate } from "../../utils/commonFunctions";

import {
  COMMISSION_AND_DECOMMISSION,
  GET_BUSINESS_DEVICES,
  SEND_PUSH_NOTIFICATION
} from "../../utils/url";
import axios from "axios";
import CustomButton from "../../components/CustomButton/Button";
import {
  Alert,
  Box,
  CircularProgress,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import MultipleSelectCheckmarks from "../../components/MultipleSelectCheckmarks/index";
import {
  businessDevicesDetailDateFields,
  businessDevicesDetailFields,
  sendPushOptions,
  showCommissionType,
  statusColor
} from "../../utils/commonConstants";
import Modal from "../../components/modal/ModalPage";
import BadgePage from "../../components/badge/BadgePage";
const apiEnpoint = process.env.REACT_APP_API_BASE_URL;

const BusinessDevices = () => {
  const accessToken: any = localStorage?.getItem("accessToken");
  const [businessDeviceData, setBusinessDeviceData] = useState<any>({});
  const [apiStatus, setApiStatus] = useState("fetching");
  const [selectedNames, setSelectedNames] = useState<any>({
    DeviceId: "",
    value: ""
  });
  const [sendPushLoading, setSendPushLoading] = useState<boolean>(false);
  const [
    commissioningandDecommissioningLoading,
    setsendCommissioningandDecommissioningLoading
  ] = useState<boolean>(false);
  const [notificationMessage, setNotificationMessage] = useState({
    message: "",
    type: ""
  });
  const [
    notificationMessageForCommissionAndDecommission,
    setNotificationMessageForCommissionAndDecommission
  ] = useState({
    message: "",
    type: ""
  });

  const { businessId } = useParams<any>();

  const [openModal, setOpenModal] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [businessDevice, setBusinessDevice] = useState<any>({});

  const handleOpenModal = (data: any) => {
    setNotificationMessageForCommissionAndDecommission({
      message: "",
      type: ""
    });
    setBusinessDevice(data);
    setOpenModal(true);
  };

  const fetchData = (token = accessToken) => {
    setApiStatus("fetching");
    var config: any = {
      method: "get",
      url: `${apiEnpoint}/${GET_BUSINESS_DEVICES}/${businessId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${token}`
      }
    };

    axios(config)
      .then(function (response: any) {
        setBusinessDeviceData(response?.data);
        setApiStatus("idle");
      })
      .catch(function (error: any) {
        setApiStatus("failed");
      });
  };

  useEffect(() => {
    if (accessToken) {
      fetchData(accessToken);
    }
  }, [accessToken]);

  const handleSelectionChange = (newSelection: string, row: any) => {
    setNotificationMessage({
      message: "",
      type: ""
    });
    setSelectedNames({ DeviceId: row?.DeviceId, value: newSelection });
  };

  const sendPushNotification = (businessdevice: any) => {
    setSendPushLoading(true);

    var data = JSON.stringify({
      DevicePushNotificationRegId: businessdevice?.RegistrationId,
      PushMessage: selectedNames ? selectedNames?.value : "",
      DeviceType: businessdevice?.DeviceType
    });

    var config: any = {
      method: "post",
      url: `${apiEnpoint}/${SEND_PUSH_NOTIFICATION}`,
      headers: {
        Authorization: `bearer ${accessToken}`,
        "Content-Type": "application/json"
      },
      data: data
    };

    axios(config)
      .then(function (response: any) {
        console.log("🚀 ~ response:", response?.data[0]?.Success);
        setSendPushLoading(false);
        // setSendPushData(response?.data);

        if (response?.data?.length > 0 && response?.data[0]?.Success) {
          setNotificationMessage({
            message: "Push notification sent successfully.",
            type: "success"
          });
        } else {
          setNotificationMessage({
            message: "Failed to send the push notification. Please try again.",
            type: "error"
          });
        }
        window?.scrollTo({ top: 0, behavior: "smooth" });
      })
      .catch(function (error) {
        setSendPushLoading(false);

        const concatenatedMessage = error?.response?.data?.Failures?.map(
          (item: any) => item?.Message
        );
        setNotificationMessage({
          message:
            concatenatedMessage?.length > 0
              ? concatenatedMessage?.join(",")
              : "Failed to send the push notification. Please try again.",
          type: "error"
        });
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
  };

  const handleCommissionAndDecommission = () => {
    setsendCommissioningandDecommissioningLoading(true);

    var data = JSON.stringify({
      MerchantDeviceId: businessDevice?.MerchantDeviceId,
      MerchantId: businessDeviceData?.response?.MerchantId
    });

    var config: any = {
      method: "post",
      url: `${apiEnpoint}/${COMMISSION_AND_DECOMMISSION}/${
        businessDevice?.IsCommissioned ? "decommission" : "commission"
      }`,
      headers: {
        Authorization: `bearer ${accessToken}`,
        "Content-Type": "application/json"
      },
      data: data
    };

    axios(config)
      .then(function (response) {
        setOpenModal(false);
        setsendCommissioningandDecommissioningLoading(false);
        fetchData(accessToken);
      })
      .catch(function (error) {
        setsendCommissioningandDecommissioningLoading(false);

        const concatenatedMessage = error?.response?.data?.Failures?.map(
          (item: any) => item?.Message
        );
        setNotificationMessageForCommissionAndDecommission({
          message:
            concatenatedMessage?.length > 0
              ? concatenatedMessage?.join(",")
              : `Failed to ${
                  businessDevice?.IsCommissioned ? "decommission" : "commission"
                } the device. Please try again.`,
          type: "error"
        });
      });
  };

  const handleVewDetail = (data: any) => {
    setBusinessDevice(data);
    setOpenViewModal(true);
  };

  const Columns: any = [
    {
      id: "MerchantDeviceId",
      label: "Merchant Device Id",
      format: (value: any) => (value ? <CopyableText text={value} /> : "-")
    },
    {
      id: "DeviceType",
      label: "Device Type",
      format: (value: string) => (value ? value : "-")
    },
    {
      id: "AppVersion",
      label: "App Version",
      format: (value: string) => (value ? value : "-")
    },
    {
      id: "PingDate",
      label: "Ping Date",
      format: (value: string) => (value ? getFormattedDate(value) : "-")
    },
    {
      id: "IsCommissioned",
      label: "Is Commissioned",
      format: (value: boolean, row: { DeviceType: string }) =>
        value ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "20px"
            }}
          >
            <BadgePage color={statusColor["yes"]?.color}>{"YES"}</BadgePage>
            {showCommissionType?.includes(row?.DeviceType?.toLowerCase()) && (
              <CustomButton callBack={() => handleOpenModal(row)}>
                {"Decommission"}
              </CustomButton>
            )}
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "20px"
            }}
          >
            <BadgePage color={statusColor["no"]?.color}>{"NO"}</BadgePage>
            {showCommissionType?.includes(row?.DeviceType?.toLowerCase()) && (
              <CustomButton callBack={() => handleOpenModal(row)}>
                {"Commission"}
              </CustomButton>
            )}
          </Box>
        )
    },
    {
      id: "",
      label: "Send Push",
      format: (
        value: string,
        row: { DeviceType: string; DeviceId: string; RegistrationId: string }
      ) =>
        showCommissionType?.includes(row?.DeviceType?.toLowerCase()) &&
        row?.RegistrationId ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "5px"
            }}
          >
            <Box sx={{ marginTop: "11px" }}>
              <MultipleSelectCheckmarks
                label="Select Option"
                options={sendPushOptions}
                selectedValues={
                  row?.DeviceId === selectedNames?.DeviceId
                    ? selectedNames?.value
                    : ""
                }
                onChange={(value: string) => handleSelectionChange(value, row)}
                inputLabelStyle={{
                  fontSize: 14,
                  transform: "translate(14px, 12px) scale(1)",
                  "&.MuiInputLabel-shrink": {
                    transform: "translate(14px, -6px) scale(0.75)"
                  }
                }}
                selectInputStyle={{
                  height: 40,
                  fontSize: 14,
                  padding: "0 14px",
                  display: "flex",
                  alignItems: "center"
                }}
              />
            </Box>
            <Box>
              <CustomButton
                disabled={
                  row?.DeviceId !== selectedNames?.DeviceId ||
                  !selectedNames?.value ||
                  sendPushLoading
                }
                callBack={() => sendPushNotification(row)}
              >
                {row?.DeviceId === selectedNames?.DeviceId &&
                sendPushLoading ? (
                  <CircularProgress size={25} color="inherit" />
                ) : (
                  "Send Push"
                )}
              </CustomButton>
            </Box>
          </Box>
        ) : (
          "-"
        )
    },
    {
      id: "Detail",
      label: "Detail",
      format: (value: boolean, row: any) => (
        <IconButton onClick={() => handleVewDetail(row)}>
          <VisibilityIcon
            sx={{
              cursor: "pointer"
            }}
          />
        </IconButton>
      )
    }
  ];

  const renderTextFields = () => {
    const rows = businessDevicesDetailFields;

    return rows.map((row: any[], rowIndex: React.Key | null | undefined) => (
      <Box
        key={rowIndex}
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          marginBottom: "10px",
          width: "100%",
          flexWrap: "wrap"
        }}
      >
        {row.map((key: any, index: any) => {
          const value = businessDevice[key];
          let displayValue = value;
          if (businessDevicesDetailDateFields.includes(key)) {
            displayValue = value ? getFormattedDate(value) : "";
          }

          return (
            <Box
              key={`${key}-${index}`}
              sx={{
                flex: 1,
                minWidth: "150px",
                marginBottom: "10px",
                "&:not(:last-of-type)": {
                  marginRight: "10px"
                }
              }}
            >
              <TextField
                disabled
                id={`${key}-${index}`}
                label={key}
                type="text"
                autoComplete={`current-${key}-${index}`}
                variant={"standard"}
                value={displayValue}
                size="medium"
                sx={{
                  width: "100%",
                  height: "55px"
                }}
                fullWidth
              />
            </Box>
          );
        })}
      </Box>
    ));
  };

  return (
    <>
      {notificationMessage?.message && (
        <div style={{ marginTop: "2px", marginBottom: "1px" }}>
          <Alert severity={notificationMessage?.type as any}>
            {notificationMessage?.message}
          </Alert>
        </div>
      )}
      {apiStatus === "idle" && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignContent: "center"
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignContent: "center"
            }}
          >
            <Typography variant="h5" align="left">
              {businessDeviceData?.response?.MerchantId ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    gap: "5px"
                  }}
                >
                  <span
                    style={{
                      verticalAlign: "middle",
                      display: "flex",
                      alignItems: "center",
                      color: "#192F67"
                    }}
                  >{`MerchantId:${" "}`}</span>
                  <CopyableText
                    text={businessDeviceData?.response?.MerchantId}
                  />
                </Box>
              ) : (
                ""
              )}
            </Typography>

            <Typography variant="h5" align="left">
              {businessDeviceData?.response?.BusinessId ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    gap: "5px"
                  }}
                >
                  <span
                    style={{
                      verticalAlign: "middle",
                      display: "flex",
                      alignItems: "center",
                      color: "#192F67"
                    }}
                  >{`BusinessId:${" "}`}</span>
                  <CopyableText
                    text={businessDeviceData?.response?.BusinessId}
                  />
                </Box>
              ) : (
                ""
              )}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: "10px",
              alignContent: "center"
            }}
          >
            <RefreshIcon onClick={() => fetchData(accessToken)} />
          </Box>
        </Box>
      )}
      <Box mt={4}>
        {businessDeviceData?.response?.Devices?.length > 0 &&
          apiStatus !== "fetching" && (
            <Typography variant="h5" align="left">
              {"Business Devices:"}
            </Typography>
          )}
        <CustomTableWithPagination
          columns={Columns}
          data={businessDeviceData?.response?.Devices}
          apiStatus={apiStatus}
          isShowPagination={false}
        />
      </Box>

      {/* Modal for Commissioning and Deccommissioning the devices  */}
      <Modal open={openModal} setOpen={setOpenModal} fullWidth={true}>
        {notificationMessageForCommissionAndDecommission?.message && (
          <div style={{ marginTop: "2px", marginBottom: "1px" }}>
            <Alert
              severity={
                notificationMessageForCommissionAndDecommission?.type as any
              }
            >
              {notificationMessageForCommissionAndDecommission?.message}
            </Alert>
          </div>
        )}
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {`Are you sure you want to proceed with ${
            businessDevice?.IsCommissioned
              ? "decommissioning "
              : "commissioning "
          } the device?`}
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => setOpenModal(false)}
          sx={{
            position: "absolute",
            right: 8,
            top: 2,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: "20px"
            }}
          >
            <CustomButton
              callBack={() => handleCommissionAndDecommission()}
              disabled={commissioningandDecommissioningLoading}
            >
              {commissioningandDecommissioningLoading ? (
                <CircularProgress size={25} color="inherit" />
              ) : (
                "Yes"
              )}
            </CustomButton>
            <CustomButton callBack={() => setOpenModal(false)}>
              {"Cancel"}
            </CustomButton>
          </Box>
        </DialogContent>
      </Modal>

      {/* Modal for view the detail  */}
      <Modal open={openViewModal} setOpen={setOpenViewModal} fullWidth={true}>
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {"Business Device Details"}
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => setOpenViewModal(false)}
          sx={{
            position: "absolute",
            right: 8,
            top: 2,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent>
          <Box sx={{ p: 2, width: "75%" }}>
            {businessDevice && renderTextFields()}
          </Box>
        </DialogContent>
      </Modal>
    </>
  );
};

export default BusinessDevices;
